import { useState } from "react";
import GModal from "../../design/components/GModal";
import Button from "../../design/Button";
import {
  chevronRight,
  topNavAccountSelectedAccountTickIcon,
} from "../../../utility-functions/assetLoader";
import { calcPrice } from "../../UpgradePlan/PlanModal1";
import AnimationPage from "../../shared/animation-page/AnimationPage";
import classes from "./ChoosePlanModal.module.css";

const billingOptions = [
  { label: "Monthly", value: "Monthly" },
  { label: "Quarterly", value: "Quarterly" },
  { label: "Annual", value: "Annual" },
];

const plans = [
  {
    id: "STANDARD",
    name: "Standard",
    features: [
      "Call logs & Reports",
      "Call recording",
      "Mobile app",
      "Click to call extension",
    ],
  },
  {
    id: "PROFESSIONAL",
    name: "Professional",
    features: [
      "Everything in Standard plan",
      "Custom reports",
      "Incoming call routing",
      "Call transfer",
      "IVR",
    ],
  },
];

const ChoosePlanModal = ({
  visible,
  handleCloseModal,
  currentType,
  currentBillingCycle,
  changePlanHandler = () => null,
  plansData = [],
}) => {

  //States
  const [selectedType, setSelectedType] = useState(
    currentType ?? "PROFESSIONAL",
  );
  const [billingCycle, setBillingCycle] = useState(
    currentBillingCycle ?? "Monthly",
  );

  return (
    <GModal
      visible={visible}
      closeModal={handleCloseModal}
      headingStyle={{ backgroundColor: "#fff", border: "none" }}
      modalStyle={{ padding: "0 40px 40px 40px" }}
      bodyWrapperStyle={{ paddingRight: "0" }}
      body={
        plansData.length === 0 ? (
          <AnimationPage />
        ) : (
          <div className={classes.modalBody}>
            <div className={classes.header}>
              <h3 className={classes.title}>Choose your plan</h3>
              <p className={classes.subtitle}>
                Select the plan that fits your team's needs
              </p>
            </div>

            <div className={classes.billingToggle}>
              {billingOptions.map((option) => (
                <div
                  key={option.value}
                  className={`${classes.billingOption} ${billingCycle === option.value ? classes.active : ""}`}
                  onClick={() => setBillingCycle(option.value)}
                >
                  {option.label}
                </div>
              ))}
            </div>

            <div className={classes.planContainer}>
              <div className={classes.plans}>
                {plans?.map((plan) => {
                  const active = selectedType === plan?.id;

                  return (
                    <div
                      key={plan?.id}
                      className={`${classes.planCard} ${active ? classes.active : ""}`}
                      onClick={() => setSelectedType(plan?.id)}
                    >
                      <div className={classes.planName}>{plan?.name}</div>
                      <div className={classes.planPriceRow}>
                        <span className={classes.price}>
                          {calcPrice(plan?.name, plansData, billingCycle)}
                        </span>
                        <span className={classes.priceUnit}>/user/mo</span>
                      </div>
                      <div className={classes.planFeatures}>
                        {plan?.features?.map((feature, idx) => (
                          <div key={idx} className={classes.featureItem}>
                            {topNavAccountSelectedAccountTickIcon(
                              "#2AA251",
                              20,
                              20,
                            )}
                            <span>{feature}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className={classes.compare}>
                <a
                  href="https://frejun.com/pricing/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.compareLink}
                >
                  Compare plans
                </a>
                {chevronRight("#2AA251", 20, 20)}
              </div>

              <Button
                hierarchy="green"
                buttonText="Continue"
                onClick={() => changePlanHandler(selectedType, billingCycle)}
                className={classes.continueBtn}
                disabled={selectedType === currentType && billingCycle === currentBillingCycle}
              />
            </div>
          </div>
        )
      }
    />
  );
};

export default ChoosePlanModal;
